<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item"><router-link to="/kr/mypage/board/myThanks"> 고맙습니다 </router-link></li>
            <li class="tab-menu__item active"><router-link to="/kr/mypage/board/myTendinous"> 건의합니다 </router-link></li>
        </ul>
    </div>
    <p class="bullet03">회원님께서 작성하신 글을 최신순으로 확인하실 수 있습니다.</p>
    <p class="bullet03">글 수정은 접수 상태일 때 제목 클릭 후 수정 가능합니다.</p>
    <div class="table-wrap">
        <div class="table board">
            <div class="table__inner">
                <table>
                    <colgroup>
                        <col style="width: 80px;">
                        <col style="width: 19%; ">
                        <col >
                        <col style="width: 20%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th></th>
                            <th>등록일자</th>
                            <th>제목</th>
                            <th>진행상황</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td colspan="4" v-if="orgList.length == 0">내역이 없습니다.</td></tr>
                        <tr v-for="(article, idx) in list">
                            <td class="checkbox">
                                <div class="checkbox-wrap">
                                    <label>
                                        <input type="checkbox" :name="`test-check${idx}`" :id="`check${idx}`" :value="article.articleNo" v-model="article.isChecked">
                                        <span class="checkbox-btn"></span>
                                    </label>
                                </div>
                            </td>
                            <td class="day">{{$commonUtils.timestampToDate(article.createdDt)}}</td>
                            <td class="title left">
                                <router-link :to="`/kr/mypage/board/myTendinousView?boardNo=11&articleNo=${article.articleNo}`">{{article.title}}</router-link>
                            </td>
                            <td class="tag">{{article.item18 == 'R' ? '접수' : '답변완료'}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="botton-wrap">
        <a href="javascript:;" class="sub-button c-point-red" @click="deleteArticle" v-if="list.length > 0">삭제</a>
    </div>

    <kr_Pagination :totCnt="totCnt" :pageRow="pageRow" :currentNum="currentNum" :pageCount="pageCount" @setNum="setNum"/>
</template>

<script>
export default {
    data() {
        return {
            orgList: [],
            list: [],
            pageList: '',
            // pageCount: window.innerWidth > 720 ? 10 : 5,
            pageCount: 5,
            totCnt: 0,

            // 게시글 parameter
            currentNum: this.$route.query.currentNum || 1,
            pageRow: 10,
        }
    },
    watch: {
        $route(to, from) {
            if(to.query.currentNum != from.query.currentNum){
                this.currentNum = to.query.currentNum
                this.sliceList()
            }
        }
    },
    methods: {
        getList(){
            this.list = []
            const boardNo = 11
            const params = {
                boardNo: boardNo,
            }
            this.axios.get(this.api.mypage.articleList, {
                params: params
            })
                .then(res => {
                    this.orgList = res.data.list
                    this.sliceList()
                    this.totCnt = res.data.list.length
                })
        },
        deleteArticle() {
            if (confirm('삭제하시겠습니까?')) {
                const boardNo = 11
                const articleNo = this.list.filter(article => article.isChecked).map(article => article.articleNo)
                
                this.axios.post(`${this.api.article.view}${boardNo}/del`, null, {
                    params: {
                        boardNo: boardNo,
                        articleNos: articleNo.join(',')
                    }
                }).then(res => {
                    this.currentNum = 1
                    this.getList()
                })
            }
        },
        sliceList(){
            const start = (this.currentNum - 1) * this.pageRow
            const end = this.currentNum * this.pageRow
            this.list = this.orgList.slice(start, end)
        },

        setNum(n){
            this.currentNum = n
            this.goPage()
        },
        goPage() {
            const obj = {currentNum: this.currentNum};
            for (const key in obj) {
                if (obj[key] === null || obj[key] === '') {
                    delete obj[key];
                }
            }

            this.$router.push({ path: this.$route.path, query: obj});
        },

    },
    mounted() {
        this.getList()
    }

}

</script>

<style scoped></style>